// JS calculo de cantidades en precios de la vsiat cart despues de hacer cambios en cantidad de producto

js_cart_total()
function js_cart_total(){
    document.addEventListener('DOMContentLoaded', initCartTotal)
}

function initCartTotal() {
    const buttons = document.querySelectorAll('.js-cart-total__button')
    const totals = document.querySelectorAll('.js-cart-total__total')
    const line_totals = document.querySelectorAll('.js-cart-total__line-total')
    
    init()
    
    function init(){
        if (buttons != null) {
            buttons.forEach(button => {
                button.addEventListener('click', ()=>{
                    checkCart()
                })
            })
        }
    }

    function checkCart() {
        const cart = JSON.parse(localStorage.atom_cart)
        printPrices(cart)
    }

    function printPrices(cart) {
        const formatter = new Intl.NumberFormat('en-US', {
            // style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        })
        
        if (totals != null) {
            totals.forEach(total => {
                total.innerHTML = '$ ' + formatter.format(cart.total_price/100)
            })
        }

        if (line_totals != null) {
            line_totals.forEach(total => {
                cart.items.forEach(item => {
                    if (total.dataset.id == item.id) {
                        total.innerHTML = '$ ' + formatter.format(item.final_line_price/100)
                    }
                })
                
            })
        }
    }
}
